import { Injectable } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import { Observable, Subject } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HubConnectionService {
  private url: string = environment.baseURL.split('/api')[0];
  private hubConnection: signalR.HubConnection | null = null;
  private messageReceived = new Subject<{ message: string }>();

  constructor() {}

  public configureHub(hubName: string, receiveEndpoint: string): void {
    this.hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(`${this.url}/${hubName}`, {
        skipNegotiation: true,
        transport: signalR.HttpTransportType.WebSockets
      })
      .withAutomaticReconnect()
      .build();

    this.startConnection();
    this.registerOnServerEvents(receiveEndpoint);
  }

  private startConnection() {
    if (this.hubConnection) {
      this.hubConnection
        .start()
        .then(() => {
          const userId = localStorage.getItem('id') || '';

          if (userId) {
            return this.hubConnection!.invoke('RegisterUserId', userId);
          } else {
            console.warn('UserId not found in localStorage');
            return Promise.resolve();
          }
        })
        .catch((err: any) =>
          console.error('Error while starting SignalR connection:', err)
        );
    } else {
      console.error('Hub connection is not initialized.');
    }
  }

  private registerOnServerEvents(receiveEndpoint: string) {
    if (this.hubConnection) {
      this.hubConnection.on(receiveEndpoint, (message: string) => {
        console.log('Received message:', message);
        this.messageReceived.next({ message });
      });
    } else {
      console.error('Hub connection is not initialized.');
    }
  }

  public getMessages(): Observable<{ message: string }> {
    return this.messageReceived.asObservable();
  }

  public stopConnection() {
    if (
      this.hubConnection &&
      this.hubConnection.state === signalR.HubConnectionState.Connected
    ) {
      this.hubConnection
        .stop()
        .then(() => console.log('SignalR connection stopped.'))
        .catch((err: any) =>
          console.error('Error while stopping SignalR connection:', err)
        );
    } else {
      console.warn('SignalR connection is not active.');
    }
  }
}
